import React from "react";
import { LandingPage } from "./pages/LandingPage";

/**
 * Landing feature routes.
 *
 *   /   Public marketing page — value prop, features, planes, CTA to
 *       /registro-academia and slug-based login. Renders bare (public: true
 *       skips the app shell in AppLayout).
 *
 * Tenant traffic never lands here: /:slug routes are owned by features/auth.
 */
const landingRoutes = [
  { path: "/", element: <LandingPage />, public: true },
];

export default landingRoutes;
